import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "scrollbar",
  style: {"max-height":"70vh","overflow-y":"auto"}
}
const _hoisted_2 = {
  style: {"border-top-width":"1px","border-top-style":"solid"},
  class: "pt-2 pl-3 pr-3 pb-2 input-border-color d-flex"
}
const _hoisted_3 = { class: "flex-fill" }

import {getCurrentInstance, onMounted, ref} from 'vue';
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "FilterablePopover"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

let model = _useModel<string>(__props, "modelValue");

let height = ref(0);

onMounted(() => {
    model.value = null;
    let el = getCurrentInstance().proxy.$el
    setTimeout(() => {
        height.value = el?.clientHeight;
    }, 10);
});



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex flex-column filterable-popover",
    style: _normalizeStyle({
            height: _unref(height) ? `${_unref(height)}px` : undefined
        })
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: _unref(model),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
          placeholder: _unref(__)('Поиск')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _renderSlot(_ctx.$slots, "after-input")
    ])
  ], 4))
}
}

})